import { render, staticRenderFns } from "./MaterialWizardPackage.vue?vue&type=template&id=266f0db6"
import script from "./MaterialWizardPackage.vue?vue&type=script&lang=js"
export * from "./MaterialWizardPackage.vue?vue&type=script&lang=js"
import style0 from "./MaterialWizardPackage.vue?vue&type=style&index=0&id=266f0db6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports